import {Snackbar, SnackbarProps} from '@mui/material';
import {styled} from '@mui/material/styles';

export interface SidebarAwareCenteredSnackbarProps extends SnackbarProps {
    mapControlsOffset: number;
}

const SnackbarRoot = styled(Snackbar, {
    shouldForwardProp: (prop) => prop !== 'mapControlsOffset',
})<SidebarAwareCenteredSnackbarProps>(({theme, mapControlsOffset}) => ({
    transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.only('xs')]: {
        // Snackbars are rendered full-width at the smallest viewport.
        // A margin prevents the snackbar from overlapping the fixed map controls
        marginLeft: 40,
        marginRight: 40,
    },
    [theme.breakpoints.up('xs')]: {
        // Ensure the snackbar does not overlap the map controls at the bottom of the screen
        bottom: theme.spacing(6),
    },
    [theme.breakpoints.up('sm')]: {
        minWidth: 'max-content',
    },
    [theme.breakpoints.up('md')]: {
        // Center the snackbar in the map, offset by the sidebar width when open
        transform: `translateX(calc(-50% + ${mapControlsOffset / 2}px))`,
    },
}));

export function SidebarAwareCenteredSnackbar(props: SidebarAwareCenteredSnackbarProps) {
    return <SnackbarRoot anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} {...props} />;
}
